<div class="summon-dialog">
  <div class="title">
    <small>
      <img class="icon" [src]="character.iconUrl" />
      {{gameManager.characterManager.characterName(character)}}
    </small>
    <span [ghs-label]="'summon'"></span>
  </div>

  <div class="container">
    <div class="color-container">
      <ng-container *ngIf="!fhSummon">
        <span *ngFor="let color of summonColors" class="summon-button" (click)="selectColor(color)"
          [ngClass]="{'active' : color == summonColor}">
          <span class="image">
            <img src="./assets/images/summons/{{color}}.png">
          </span>
        </span>
      </ng-container>
      <span *ngFor="let number of [] | ghsRange:8" class="number-button" (click)="pickNumber(number+1)"
        [ngClass]="{'disabled' : summonNumber == number+1}">
        <span class="number">{{number+1}}</span>
      </span>
    </div>
    <div class="scroll-container summons">
      <ng-container *ngFor="let summonData of summonData; let i = index">
        <span *ngIf="showAll || summonNumbers[i] != -1" class="summon" (click)="addSummon(summonData)"
          [ngClass]="{'disabled' : summonNumbers[i] == -1 || !available(summonData,summonNumber || summonNumbers[i])}">
          <span class="summon-button">
            <span class="image" [ngClass]="{'fh': fhSummon}">
              <img *ngIf="!fhSummon && summonData.special" src="./assets/images/summons/custom.png">
              <img *ngIf="!fhSummon && !summonData.special" src="./assets/images/summons/{{summonColor}}.png">
              <span class="summon-number">{{summonNumber ? summonNumber : (summonNumbers[i] != -1 ? summonNumbers[i] :
                '-')}}</span>
            </span>
          </span>
          <label>
            <span [ghs-label]="'data.summon.' + summonData.name"></span>
            <span class="level-hint" *ngIf="showLevel(summonData)" [ghs-label]="'character.summon.level'"
              [ghs-label-args]="[summonData.level || 1]"></span>
          </label>
          <ng-container *ngIf="summonData.thumbnail && !summonData.noThumbnail || summonData.thumbnailUrl">
            <span class="spacer"></span>
            <span class="thumbnail">
              <img
                [src]="summonData.thumbnailUrl ? summonData.thumbnailUrl :  './assets/images/summons/thumbnail/' + summonData.edition + '-' + summonData.name + '.png'" />
            </span>
          </ng-container>
        </span>
      </ng-container>
      <span class="summon" *ngIf="!summonFilter" [ngClass]="{'disabled': !summonNumber}">
        <span class="summon-button" (click)="addCustomSummon()" [ngClass]="{'disabled' : customDisabled()}">
          <span class="image" [ngClass]="{'fh': fhSummon}">
            <img *ngIf="!fhSummon" src="./assets/images/summons/{{summonColor}}.png">
            <span class="summon-number">{{summonNumber ? summonNumber : '-'}}</span>
          </span>
        </span>
        <input type="text" [value]="summonName" (change)="setSummonName($event)" (keyup)="setSummonName($event)"
          [ghs-label]="'summon.name'" [ghs-label-attribute]="'placeholder'" />
        <span class="add-summon-button" (click)="addCustomSummon()" [ngClass]="{'disabled' : customDisabled()}">
          <img class="ghs-svg" src="./assets/images/plus.svg">
        </span>
      </span>
    </div>
  </div>
</div>